import { render, staticRenderFns } from "./DeleteProducerCommissionDialog.vue?vue&type=template&id=4f3c0493&scoped=true"
import script from "./DeleteProducerCommissionDialog.vue?vue&type=script&lang=js"
export * from "./DeleteProducerCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c0493",
  null
  
)

export default component.exports